import React, { useEffect } from 'react';
import '../css/cardLimiteDeCredito.css';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

function LimiteCard({ cliente }) {
    const limiteTotal = cliente.limite;
    const limiteDisp = cliente.saldoDisponivel;
    const limiteUtilizado = limiteTotal - limiteDisp;
    const limiteDisponivel = limiteUtilizado > limiteTotal ? 0 : limiteDisp;


    const data = [
        { name: 'Disponível', value: limiteDisponivel },
        { name: 'Utilizado', value: limiteUtilizado },
    ];

    const COLORS = ['#00BE9C', '#F6C219']; // Verde para disponível, amarelo para utilizado

    return (
        <div className="card credit-limit-card">
            <div className="credit-limit-header">
                <h3 className='titulo'>Limite de crédito</h3>
                <p><b>R$ {parseFloat(limiteTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></p>
            </div>

            <div className="credit-limit-chart">
                <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                        <Pie
                            data={data}
                            innerRadius={60}
                            outerRadius={100}
                            dataKey="value"
                            startAngle={180}
                            endAngle={0}
                            paddingAngle={3}
                            isAnimationActive={true}  // Ativa a animação
                            animationDuration={1000}  // Duração da animação em milissegundos
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <div className="credit-limit-values">
                <div className="limite-disponivel">
                    <p style={{ color: '#00BE9C' }}>R$ {parseFloat(limiteDisp).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                    <p>Disponível</p>
                </div>
                <div className="limite-utilizado">
                    <p style={{ color: '#F6C219' }}>R$ {parseFloat(limiteUtilizado).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                    <p>Utilizado</p>
                </div>
            </div>
        </div>
    );
}

export default LimiteCard;
